import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Typography,
  InputNumber,
  Input
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";

const PosVolumeReportTableFilter = (props) => {
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getBanks();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/PosTransaction/AddedBanks?$select=id,name`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const onFinish = (values) => {
    {
      let query = {
        "installmentCountStart":0,
        "installmentCountEnd":0,
        "totalCommissionAmountStart":0,
        "totalCommissionAmountEnd":0,
        "startDate":"0001-01-01 00:00:00",
        "endDate":"0001-01-01 00:00:00",
        "valueStartDate":"0001-01-01 00:00:00",
        "valueEndDate":"0001-01-01 00:00:00",
        "bankId":0
      };

      if (values.bankId) {
        query.bankId = values.bankId;
      }

      if (values.dateRange) {
        [query.startDate, query.endDate] = values.dateRange;
      }
      if (values.valueDateRange) {
        [query.valueStartDate, query.valueEndDate] = values.valueDateRange;
      }
      if (values.installmentCountStart)
        query.installmentCountStart = values.installmentCountStart;
      if (values.installmentCountEnd)
        query.installmentCountEnd = values.installmentCountEnd;
      if (values.totalCommissionAmountStart)
        query.totalCommissionAmountStart = values.totalCommissionAmountStart;
      if (values.totalCommissionAmountEnd)
        query.totalCommissionAmountEnd = values.totalCommissionAmountEnd;

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel
            header="Filtreleme için tıklayınız."
            extra={
              props.extraText ? (
                <Typography>
                  <Typography.Paragraph
                    style={{
                      marginBottom: 0,
                      fontSize: "80%",
                    }}
                    type="secondary"
                  >
                    {props.extraText}
                  </Typography.Paragraph>
                </Typography>
              ) : null
            }
          >
            <Form
              name="valueReportFilter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={bankSelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={4}>
                  <Form.Item name="dateRange" label="İşlem Tarihi :">
                    <DatePicker.RangePicker
                      style={{ width: "100%" }}
                      picker={props.monthly ? "month" : "date"}
                      format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"}
                    />
                  </Form.Item>
                </Col>

                
                <Col xs={24} md={12} lg={4}>
                  <Form.Item name="valueDateRange" label="Valör Tarihi :">
                    <DatePicker.RangePicker
                      style={{ width: "100%" }}
                      picker={props.monthly ? "month" : "date"}
                      format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Taksit Sayısı :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="installmentCountStart">
                            <InputNumber
                              style={{ width: "100%" }}
                              min={1}
                              max={12}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="installmentCountEnd">
                            <InputNumber
                              style={{ width: "100%" }}
                              min={1}
                              max={12}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Komisyon Tutarı :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="totalCommissionAmountStart">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="totalCommissionAmountEnd">
                            <InputNumber
                              style={{ width: "100%" }}
                              precision={2}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default PosVolumeReportTableFilter;
